import styled from "styled-components";
import { dispositivo } from "../Dispositivos";
import IconButton from "@material-ui/core/IconButton";
import { keyframes } from "styled-components";

// Animación para el modal
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateY(-20px); }
  to { transform: translateY(0); }
`;

export const ModalBody = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 2000;
  overflow-y: auto;
  padding: 2rem 0;
  animation: ${fadeIn} 0.3s ease-out;
  backdrop-filter: blur(4px);
`;

export const ModalContainer = styled.div`
  position: relative;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 1200px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.3s ease-out;
  overflow: hidden;

  @media ${dispositivo.tablet} {
    width: 70%;
  }

  @media ${dispositivo.laptop} {
    width: 60%;
  }

  @media ${dispositivo.laptopL} {
    width: 50%;
  }
`;

export const ModalButtonContainer = styled.div`
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: flex-end;
`;

export const ModalButton = styled(IconButton)`
  && {
    margin: 0;
    padding: 8px;
    color: #666;
    transition: all 0.2s ease;

    &:hover {
      color: #333;
      background-color: rgba(0, 0, 0, 0.05);
    }

    &:focus {
      outline: 2px solid #3d53e5;
      outline-offset: 2px;
    }
  }
`;

export const ModalChildrenContainer = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex-grow: 1;

  @media ${dispositivo.tablet} {
    padding: 2rem;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;